import axios from 'axios';
import { pickBy } from 'lodash';
import { apiSessionProfilesUrl } from '../config';
import populatePropertys from '../utils/populatePropertys';

/**
 * GET Profile VO.
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {string} [props.context=user] - user | default
 * @param {string} [props.profileUUID] - target profileUUID
 * @param {boolean} [props.refresh=false] - refresh
 * @param {boolean} [props.useCache=true] - use cache
 * @returns {Promise}
 */
const getProfileVO = (props = {}) => {
  const {
    context = 'user',
    refresh = false,
    requestConfig,
    useCache = true
  } = props;

  const method = 'get';
  const url = apiSessionProfilesUrl.replace(/{context}/g, context);

  const populatedPropertys = populatePropertys({
    capDestProp: true,
    propertyNames: ['context', 'profileUUID'],
    source: props
  });

  const params = pickBy(
    {
      UseCache: useCache,
      Refresh: refresh,
      ...populatedPropertys
    },
    property => typeof property !== 'undefined'
  );

  return axios({
    method,
    params,
    url,
    ...requestConfig
  });
};

export default getProfileVO;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/getProfileVO.js